import axios from 'axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  json: true
})

export default {
  async execute(method, resource, data) {
    return client({
      method,
      url: resource,
      data
    }).then(req => {
      return req.data
    })
  }
}
